import styled from 'styled-components'

export const SettingsContainer = styled.div`
  justify-content: space-between;
  display: flex;
  flex-direction: row;
  color: ${({ theme }) => theme.textColor};
  width: 75vw;
`

export const ModalContainer = styled.div`
  margin: 30px 64px;
  width: 100%;
  min-height: 470px;
  gap: 20px;
  display: flex;
  flex-direction: column;
`
